import { useState, useEffect } from 'react';
import './RefMobile.css';

const NAV_PAGES = ['home', 'membres', 'agenda', 'messages', 'profil'];

export default function RefMobile() {
  const [currentPage, setCurrentPage] = useState('home');
  const [history, setHistory] = useState(['home']);

  // Tabs locaux
  const [memberTab, setMemberTab] = useState('Tous (247)');
  const [agendaTab, setAgendaTab] = useState('Tout');
  const [docTab, setDocTab] = useState('Tous');

  // Charger les Google Fonts (Caveat + Plus Jakarta Sans)
  useEffect(() => {
    const id = 'refmob-fonts';
    if (!document.getElementById(id)) {
      const link = document.createElement('link');
      link.id = id;
      link.rel = 'stylesheet';
      link.href = 'https://fonts.googleapis.com/css2?family=Caveat:wght@600;700&family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&display=swap';
      document.head.appendChild(link);
    }
  }, []);

  const showPage = (name) => {
    setCurrentPage(name);
    setHistory((h) => (h[h.length - 1] === name ? h : [...h, name]));
    // Reset scroll de la page courante au prochain tick
    setTimeout(() => {
      const el = document.getElementById('page-' + name);
      if (el) el.scrollTop = 0;
    }, 0);
  };

  const goBack = () => {
    setHistory((h) => {
      if (h.length <= 1) return h;
      const newH = h.slice(0, -1);
      const prev = newH[newH.length - 1];
      setCurrentPage(prev);
      return newH;
    });
  };

  const pageClass = (name) => 'page' + (currentPage === name ? ' active' : '');

  return (
    <div className="refmob-root" data-testid="refmobile-root">
      <div className="phone" data-testid="refmobile-phone">
        <div className="notch"></div>

        {/* STATUS BAR */}
        <div className="status-bar">
          <span className="status-time">9:41</span>
          <div className="status-right">
            <span>●●●</span><span>WiFi</span><span>🔋</span>
          </div>
        </div>

        {/* PAGES */}
        <div className="pages">

          {/* ═══ PAGE : ACCUEIL ═══ */}
          <div className={pageClass('home')} id="page-home" data-testid="page-home">
            <div className="app-header">
              <div className="header-top">
                <div className="logo">Ref</div>
                <div className="hdr-actions">
                  <div className="icon-btn" onClick={() => showPage('notifications')} data-testid="btn-open-notifications">
                    🔔<div className="dot-notif"></div>
                  </div>
                  <div className="icon-btn">🔍</div>
                </div>
              </div>
              <div className="welcome-card">
                <div className="wc-greet">Bonjour 👋</div>
                <div className="wc-name">Marie <span>Dupont</span></div>
                <div className="chip">✅ Membre actif · 2024</div>
              </div>
            </div>

            <div className="stats-row">
              <div className="stat-card hl"><div className="stat-val">247</div><div className="stat-lbl">Membres</div></div>
              <div className="stat-card"><div className="stat-val">8</div><div className="stat-lbl">Événements</div></div>
              <div className="stat-card"><div className="stat-val">12</div><div className="stat-lbl">Messages</div></div>
            </div>

            <div className="section">
              <div className="sec-hdr"><div className="sec-title">Actions rapides</div></div>
              <div className="quick-grid">
                <div className="qi" onClick={() => showPage('agenda')} data-testid="quick-agenda"><div className="qi-icon qi-c">📅</div><div className="qi-lbl">Agenda</div></div>
                <div className="qi" onClick={() => showPage('messages')} data-testid="quick-messages"><div className="qi-icon qi-d">💬</div><div className="qi-lbl">Messages</div></div>
                <div className="qi" onClick={() => showPage('paiements')} data-testid="quick-paiements"><div className="qi-icon qi-d">💳</div><div className="qi-lbl">Payer</div></div>
                <div className="qi" onClick={() => showPage('documents')} data-testid="quick-documents"><div className="qi-icon qi-d">📁</div><div className="qi-lbl">Docs</div></div>
              </div>
            </div>

            <div className="section">
              <div className="sec-hdr">
                <div className="sec-title">Prochains événements</div>
                <div className="sec-link" onClick={() => showPage('agenda')}>Voir tout</div>
              </div>
            </div>
            <div className="ev-scroll">
              <div className="ev-card feat"><div className="ev-tag t-c">À venir</div><div className="ev-name">Tournoi de Pétanque</div><div className="ev-date">📍 15 Juin · 10h00</div><div className="ev-foot"><div className="ev-spots"><strong>32</strong>/50</div><button className="btn-xs">S'inscrire</button></div></div>
              <div className="ev-card"><div className="ev-tag t-o">Bientôt complet</div><div className="ev-name">Assemblée Générale</div><div className="ev-date">📍 22 Juin · 19h00</div><div className="ev-foot"><div className="ev-spots"><strong>89</strong>/120</div><button className="btn-xs">S'inscrire</button></div></div>
              <div className="ev-card"><div className="ev-tag t-c">Ouvert</div><div className="ev-name">Randonnée Beaujolais</div><div className="ev-date">📍 5 Juil · 8h30</div><div className="ev-foot"><div className="ev-spots"><strong>18</strong>/30</div><button className="btn-xs">S'inscrire</button></div></div>
            </div>

            <div className="section">
              <div className="sec-hdr">
                <div className="sec-title">Actualités</div>
                <div className="sec-link" onClick={() => showPage('actualites')}>Voir tout</div>
              </div>
            </div>
            <div className="post-card" onClick={() => showPage('actualites')}>
              <div className="post-img">🏆</div>
              <div className="post-tag t-c" style={{ borderRadius: '6px', fontSize: '10px', fontWeight: 700, padding: '3px 8px' }}>Actualité</div>
              <div className="post-title">Résultats du tournoi de printemps !</div>
              <div className="post-meta">Marie Dupont · Il y a 2 jours</div>
            </div>

            <div className="section">
              <div className="sec-hdr">
                <div className="sec-title">Membres récents</div>
                <div className="sec-link" onClick={() => showPage('membres')}>Annuaire</div>
              </div>
            </div>
            <div className="m-item"><div className="m-av" style={{ background: 'var(--cyan)', color: '#0b0f0e' }}>JM</div><div className="m-info"><div className="m-name">Jean Martin</div><div className="m-sub">Membre · ADH-2024-002</div></div><div className="m-dot md-on"></div></div>
            <div className="m-item"><div className="m-av" style={{ background: 'var(--purple)', color: 'white' }}>SB</div><div className="m-info"><div className="m-name">Sophie Bernard</div><div className="m-sub">Admin · ADH-2024-003</div></div><div className="m-dot md-on"></div></div>
            <div className="m-item"><div className="m-av" style={{ background: 'var(--orange)', color: '#0b0f0e' }}>PD</div><div className="m-info"><div className="m-name">Pierre Durand</div><div className="m-sub">Membre · En attente</div></div><div className="m-dot md-pend"></div></div>
            <div className="spacer"></div>
          </div>

          {/* ═══ PAGE : MEMBRES ═══ */}
          <div className={pageClass('membres')} id="page-membres" data-testid="page-membres">
            <div className="app-header">
              <div className="header-top"><div className="page-title-h">Membres</div><div className="icon-btn">＋</div></div>
              <div className="search-bar"><span>🔍</span><input type="text" placeholder="Rechercher un membre..." /></div>
            </div>
            <div className="section" style={{ marginBottom: '8px' }}>
              <div style={{ display: 'flex', gap: '6px', overflowX: 'auto', scrollbarWidth: 'none' }}>
                {['Tous (247)', 'Actifs', 'En attente', 'Expirés'].map((t) => (
                  <div
                    key={t}
                    className={'atab' + (memberTab === t ? ' active' : '')}
                    onClick={() => setMemberTab(t)}
                    data-testid={`member-tab-${t}`}
                  >{t}</div>
                ))}
              </div>
            </div>
            <div className="m-item"><div className="m-av" style={{ background: 'var(--cyan)', color: '#0b0f0e' }}>MD</div><div className="m-info"><div className="m-name">Marie Dupont</div><div className="m-sub">Admin · ADH-2024-001</div></div><div className="m-dot md-on"></div></div>
            <div className="m-item"><div className="m-av" style={{ background: 'var(--cyan)', color: '#0b0f0e' }}>JM</div><div className="m-info"><div className="m-name">Jean Martin</div><div className="m-sub">Membre · ADH-2024-002</div></div><div className="m-dot md-on"></div></div>
            <div className="m-item"><div className="m-av" style={{ background: 'var(--purple)', color: 'white' }}>SB</div><div className="m-info"><div className="m-name">Sophie Bernard</div><div className="m-sub">Admin · ADH-2024-003</div></div><div className="m-dot md-on"></div></div>
            <div className="m-item"><div className="m-av" style={{ background: 'var(--orange)', color: '#0b0f0e' }}>PD</div><div className="m-info"><div className="m-name">Pierre Durand</div><div className="m-sub">Membre · En attente</div></div><div className="m-dot md-pend"></div></div>
            <div className="m-item"><div className="m-av" style={{ background: 'linear-gradient(135deg,#22d3a0,#4f8aff)', color: 'white' }}>AL</div><div className="m-info"><div className="m-name">Alice Leroy</div><div className="m-sub">Membre · ADH-2024-005</div></div><div className="m-dot md-on"></div></div>
            <div className="m-item"><div className="m-av" style={{ background: 'var(--red)', color: 'white' }}>TM</div><div className="m-info"><div className="m-name">Thomas Moreau</div><div className="m-sub">Membre · Expiré</div></div><div className="m-dot md-off"></div></div>
            <div className="m-item"><div className="m-av" style={{ background: '#4f8aff', color: 'white' }}>LB</div><div className="m-info"><div className="m-name">Laura Bernard</div><div className="m-sub">Membre · ADH-2024-007</div></div><div className="m-dot md-on"></div></div>
            <div className="m-item"><div className="m-av" style={{ background: '#ff8c42', color: 'white' }}>CR</div><div className="m-info"><div className="m-name">Claire Rousseau</div><div className="m-sub">Membre · ADH-2024-008</div></div><div className="m-dot md-on"></div></div>
            <div className="spacer"></div>
          </div>

          {/* ═══ PAGE : AGENDA ═══ */}
          <div className={pageClass('agenda')} id="page-agenda" data-testid="page-agenda">
            <div className="app-header">
              <div className="header-top"><div className="page-title-h">Agenda</div><div className="icon-btn">＋</div></div>
            </div>
            <div className="agenda-tabs">
              {['Tout', 'Juin', 'Juillet', 'Août'].map((t) => (
                <div
                  key={t}
                  className={'atab' + (agendaTab === t ? ' active' : '')}
                  onClick={() => setAgendaTab(t)}
                  data-testid={`agenda-tab-${t}`}
                >{t}</div>
              ))}
            </div>
            <div className="agenda-day">
              <div className="day-label">Lundi 10 Juin</div>
              <div className="agenda-ev cyan"><div className="ag-time">09:00</div><div className="ag-info"><div className="ag-title">Réunion Bureau</div><div className="ag-meta">📍 Siège social · 1h00</div></div><div className="ag-badge t-c">Confirmé</div></div>
            </div>
            <div className="agenda-day">
              <div className="day-label">Samedi 15 Juin</div>
              <div className="agenda-ev cyan"><div className="ag-time">10:00</div><div className="ag-info"><div className="ag-title">Tournoi de Pétanque</div><div className="ag-meta">📍 Parc Tête d'Or · 8h00</div></div><div className="ag-badge t-c">Inscrit</div></div>
            </div>
            <div className="agenda-day">
              <div className="day-label">Samedi 22 Juin</div>
              <div className="agenda-ev orange"><div className="ag-time">19:00</div><div className="ag-info"><div className="ag-title">Assemblée Générale</div><div className="ag-meta">📍 Salle des fêtes · 2h00</div></div><div className="ag-badge t-o">Bientôt complet</div></div>
            </div>
            <div className="agenda-day">
              <div className="day-label">Vendredi 28 Juin</div>
              <div className="agenda-ev purple"><div className="ag-time">18:30</div><div className="ag-info"><div className="ag-title">Soirée membres</div><div className="ag-meta">📍 Bar Le Central · 3h00</div></div><div className="ag-badge" style={{ background: 'rgba(124,92,252,0.12)', color: 'var(--purple)', border: '1px solid rgba(124,92,252,0.2)', fontSize: '10px', fontWeight: 700, padding: '3px 8px', borderRadius: '6px' }}>Ouvert</div></div>
            </div>
            <div className="agenda-day">
              <div className="day-label">Samedi 5 Juillet</div>
              <div className="agenda-ev cyan"><div className="ag-time">08:30</div><div className="ag-info"><div className="ag-title">Randonnée Beaujolais</div><div className="ag-meta">📍 Place Bellecour · 6h00</div></div><div className="ag-badge t-c">Ouvert</div></div>
            </div>
            <div className="spacer"></div>
          </div>

          {/* ═══ PAGE : MESSAGES ═══ */}
          <div className={pageClass('messages')} id="page-messages" data-testid="page-messages">
            <div className="app-header">
              <div className="header-top"><div className="page-title-h">Messages</div><div className="icon-btn">✏️</div></div>
              <div className="search-bar"><span>🔍</span><input type="text" placeholder="Rechercher..." /></div>
            </div>
            <div className="msg-item"><div className="msg-av-w"><div className="msg-av" style={{ background: 'var(--cyan)', color: '#0b0f0e' }}>JM</div><div className="msg-online"></div></div><div className="msg-info"><div className="msg-row"><span className="msg-name">Jean Martin</span><span className="msg-time">09:32</span></div><div className="msg-prev">Tu as vu l'événement du 15 juin ?</div></div><div className="msg-unread">3</div></div>
            <div className="msg-item"><div className="msg-av-w"><div className="msg-av" style={{ background: 'var(--purple)', color: 'white' }}>SB</div></div><div className="msg-info"><div className="msg-row"><span className="msg-name">Sophie Bernard</span><span className="msg-time">Hier</span></div><div className="msg-prev">Réunion bureau vendredi 18h ✅</div></div></div>
            <div className="msg-item"><div className="msg-av-w"><div className="msg-av" style={{ background: 'var(--orange)', color: '#0b0f0e' }}>PD</div></div><div className="msg-info"><div className="msg-row"><span className="msg-name">Pierre Durand</span><span className="msg-time">Lun</span></div><div className="msg-prev">Merci pour la validation 🙏</div></div></div>
            <div className="msg-item"><div className="msg-av-w"><div className="msg-av" style={{ background: 'linear-gradient(135deg,#22d3a0,#4f8aff)', color: 'white' }}>AL</div></div><div className="msg-info"><div className="msg-row"><span className="msg-name">Alice Leroy</span><span className="msg-time">Dim</span></div><div className="msg-prev">Super initiative, je suis partante !</div></div></div>
            <div className="msg-item"><div className="msg-av-w"><div className="msg-av" style={{ background: 'var(--red)', color: 'white' }}>TM</div></div><div className="msg-info"><div className="msg-row"><span className="msg-name">Thomas Moreau</span><span className="msg-time">Sam</span></div><div className="msg-prev">On se retrouve à quelle heure ?</div></div></div>
            <div className="msg-item"><div className="msg-av-w"><div className="msg-av" style={{ background: '#4f8aff', color: 'white' }}>LB</div></div><div className="msg-info"><div className="msg-row"><span className="msg-name">Laura Bernard</span><span className="msg-time">Ven</span></div><div className="msg-prev">Le doc est disponible dans l'espace</div></div></div>
            <div className="spacer"></div>
          </div>

          {/* ═══ PAGE : PROFIL ═══ */}
          <div className={pageClass('profil')} id="page-profil" data-testid="page-profil">
            <div className="profile-hero">
              <div className="profile-av">MD</div>
              <div className="profile-name">Marie Dupont</div>
              <div className="profile-email">admin@asso-ref.fr</div>
              <div className="chip">Admin · Sport &amp; Culture Lyon</div>
            </div>

            <div className="section"><div className="sec-title" style={{ marginBottom: '12px' }}>Ma carte membre</div></div>
            <div className="dig-card">
              <div className="dc-top"><div className="dc-logo">Ref</div><div className="dc-badge">Actif 2024</div></div>
              <div className="dc-name">Marie Dupont</div>
              <div className="dc-num">ADH · 2024 · 0001</div>
              <div className="dc-foot"><div className="dc-val">Valide jusqu'au<strong>31 déc. 2024</strong></div><div className="dc-qr">⬛</div></div>
            </div>

            <div className="section">
              <div className="sec-title" style={{ marginBottom: '12px' }}>Mon compte</div>
              <div className="card">
                <div className="profile-row" onClick={() => showPage('paiements')} data-testid="profile-row-paiements"><div className="pr-icon pr-c">💳</div><div className="pr-label">Cotisations &amp; paiements</div><div className="pr-arrow">›</div></div>
                <div className="profile-row" onClick={() => showPage('documents')} data-testid="profile-row-documents"><div className="pr-icon pr-d">📁</div><div className="pr-label">Mes documents</div><div className="pr-arrow">›</div></div>
                <div className="profile-row" onClick={() => showPage('projets')} data-testid="profile-row-projets"><div className="pr-icon pr-d">📋</div><div className="pr-label">Mes projets</div><div className="pr-arrow">›</div></div>
                <div className="profile-row"><div className="pr-icon pr-d">⚙️</div><div className="pr-label">Paramètres</div><div className="pr-arrow">›</div></div>
                <div className="profile-row"><div className="pr-icon pr-r">🚪</div><div className="pr-label" style={{ color: 'var(--red)' }}>Se déconnecter</div><div className="pr-arrow">›</div></div>
              </div>
            </div>
            <div className="spacer"></div>
          </div>

          {/* ═══ PAGE : DOCUMENTS ═══ */}
          <div className={pageClass('documents')} id="page-documents" data-testid="page-documents">
            <div className="app-header">
              <div className="header-top">
                <div className="page-back" onClick={goBack} data-testid="back-documents">← Documents</div>
                <div className="icon-btn">＋</div>
              </div>
              <div className="search-bar"><span>🔍</span><input type="text" placeholder="Rechercher un document..." /></div>
            </div>
            <div className="section" style={{ marginBottom: '8px' }}>
              <div style={{ display: 'flex', gap: '6px', overflowX: 'auto', scrollbarWidth: 'none' }}>
                {['Tous', 'PDF', 'Images', 'Autres'].map((t) => (
                  <div
                    key={t}
                    className={'atab' + (docTab === t ? ' active' : '')}
                    onClick={() => setDocTab(t)}
                    data-testid={`doc-tab-${t}`}
                  >{t}</div>
                ))}
              </div>
            </div>
            <div className="doc-item"><div className="doc-icon di-pdf">📄</div><div className="doc-info"><div className="doc-name">Statuts association 2024.pdf</div><div className="doc-meta">Ajouté le 12 jan · Marie D.</div></div><div className="doc-size">2.4 Mo</div></div>
            <div className="doc-item"><div className="doc-icon di-doc">📝</div><div className="doc-info"><div className="doc-name">Règlement intérieur.docx</div><div className="doc-meta">Ajouté le 5 jan · Sophie B.</div></div><div className="doc-size">890 Ko</div></div>
            <div className="doc-item"><div className="doc-icon di-pdf">📄</div><div className="doc-info"><div className="doc-name">PV Assemblée Générale 2023.pdf</div><div className="doc-meta">Ajouté le 20 déc · Marie D.</div></div><div className="doc-size">1.2 Mo</div></div>
            <div className="doc-item"><div className="doc-icon di-img">🖼️</div><div className="doc-info"><div className="doc-name">Photos tournoi printemps.zip</div><div className="doc-meta">Ajouté le 18 déc · Jean M.</div></div><div className="doc-size">14 Mo</div></div>
            <div className="doc-item"><div className="doc-icon di-pdf">📄</div><div className="doc-info"><div className="doc-name">Budget prévisionnel 2024.pdf</div><div className="doc-meta">Ajouté le 2 jan · Sophie B.</div></div><div className="doc-size">540 Ko</div></div>
            <div className="doc-item"><div className="doc-icon di-doc">📝</div><div className="doc-info"><div className="doc-name">Calendrier annuel 2024.xlsx</div><div className="doc-meta">Ajouté le 8 jan · Marie D.</div></div><div className="doc-size">230 Ko</div></div>
            <div className="spacer"></div>
          </div>

          {/* ═══ PAGE : PROJETS ═══ */}
          <div className={pageClass('projets')} id="page-projets" data-testid="page-projets">
            <div className="app-header">
              <div className="header-top">
                <div className="page-back" onClick={goBack} data-testid="back-projets">← Projets</div>
                <div className="icon-btn">＋</div>
              </div>
            </div>
            <div className="section">
              <div className="proj-card">
                <div className="proj-head"><div className="proj-name">Tournoi annuel 2024</div><div className="proj-status ps-active">En cours</div></div>
                <div className="proj-desc">Organisation du grand tournoi de pétanque annuel — logistique, inscriptions, récompenses.</div>
                <div className="proj-progress"><div className="pp-fill" style={{ width: '72%' }}></div></div>
                <div className="proj-meta"><span>72% complété</span><span>5 tâches restantes</span></div>
              </div>
              <div className="proj-card">
                <div className="proj-head"><div className="proj-name">Refonte site web association</div><div className="proj-status ps-active">En cours</div></div>
                <div className="proj-desc">Mise à jour du site public avec les nouvelles couleurs et les nouvelles pages.</div>
                <div className="proj-progress"><div className="pp-fill" style={{ width: '35%' }}></div></div>
                <div className="proj-meta"><span>35% complété</span><span>11 tâches restantes</span></div>
              </div>
              <div className="proj-card">
                <div className="proj-head"><div className="proj-name">Recrutement nouveaux membres</div><div className="proj-status ps-active">En cours</div></div>
                <div className="proj-desc">Campagne de communication pour attirer de nouveaux adhérents pour la saison 2024-2025.</div>
                <div className="proj-progress"><div className="pp-fill" style={{ width: '55%' }}></div></div>
                <div className="proj-meta"><span>55% complété</span><span>7 tâches restantes</span></div>
              </div>
              <div className="proj-card">
                <div className="proj-head"><div className="proj-name">AG 2023 — Compte-rendu</div><div className="proj-status ps-done">Terminé</div></div>
                <div className="proj-desc">Rédaction et diffusion du compte-rendu de l'assemblée générale 2023.</div>
                <div className="proj-progress"><div className="pp-fill" style={{ width: '100%' }}></div></div>
                <div className="proj-meta"><span>100% complété</span><span>0 tâche restante</span></div>
              </div>
            </div>
            <div className="spacer"></div>
          </div>

          {/* ═══ PAGE : PAIEMENTS ═══ */}
          <div className={pageClass('paiements')} id="page-paiements" data-testid="page-paiements">
            <div className="app-header">
              <div className="header-top">
                <div className="page-back" onClick={goBack} data-testid="back-paiements">← Paiements</div>
              </div>
            </div>
            <div className="section">
              <div className="card" style={{ padding: '16px', marginBottom: '14px', background: 'linear-gradient(135deg,#0d2420,#091a16)', borderColor: 'var(--cyan-border)' }}>
                <div style={{ fontSize: '12px', color: 'var(--muted)', marginBottom: '4px' }}>Solde total cotisations</div>
                <div style={{ fontSize: '32px', fontWeight: 800, color: 'var(--cyan)', marginBottom: '2px' }}>55,00 €</div>
                <div style={{ fontSize: '12px', color: 'var(--muted)' }}>Payé · Exercice 2024</div>
              </div>
              <button className="btn-full" style={{ marginBottom: '8px' }} data-testid="btn-payer-cotisation">Payer ma cotisation 2025</button>
              <button className="btn-outline" data-testid="btn-telecharger-recus">Télécharger mes reçus</button>
            </div>
            <div className="section">
              <div className="sec-title" style={{ marginBottom: '12px' }}>Historique</div>
              <div className="card">
                <div className="pay-item"><div className="pay-icon" style={{ background: 'var(--cyan-soft)' }}>✅</div><div className="pay-info"><div className="pay-name">Cotisation annuelle 2024</div><div className="pay-date">12 janv. 2024</div></div><div className="pay-amt pa-pos">+30€</div></div>
                <div className="pay-item"><div className="pay-icon" style={{ background: 'var(--cyan-soft)' }}>✅</div><div className="pay-info"><div className="pay-name">Tournoi printemps — inscription</div><div className="pay-date">5 mars 2024</div></div><div className="pay-amt pa-neg">-5€</div></div>
                <div className="pay-item"><div className="pay-icon" style={{ background: 'var(--cyan-soft)' }}>✅</div><div className="pay-info"><div className="pay-name">Cotisation annuelle 2023</div><div className="pay-date">8 fév. 2023</div></div><div className="pay-amt pa-pos">+25€</div></div>
                <div className="pay-item"><div className="pay-icon" style={{ background: 'var(--cyan-soft)' }}>✅</div><div className="pay-info"><div className="pay-name">Sortie randonnée 2023</div><div className="pay-date">15 juil. 2023</div></div><div className="pay-amt pa-neg">-8€</div></div>
              </div>
            </div>
            <div className="spacer"></div>
          </div>

          {/* ═══ PAGE : ACTUALITÉS ═══ */}
          <div className={pageClass('actualites')} id="page-actualites" data-testid="page-actualites">
            <div className="app-header">
              <div className="header-top"><div className="page-title-h">Actualités</div><div className="icon-btn">✏️</div></div>
            </div>
            <div className="post-card">
              <div className="post-img">🏆</div>
              <div className="post-tag t-c" style={{ borderRadius: '6px', fontSize: '10px', fontWeight: 700, padding: '3px 8px' }}>Résultats</div>
              <div className="post-title">Résultats du tournoi de printemps !</div>
              <div className="post-meta">Marie Dupont · 2 juin 2024 · 3 min de lecture</div>
            </div>
            <div className="post-card">
              <div className="post-img">📢</div>
              <div className="post-tag t-o" style={{ borderRadius: '6px', fontSize: '10px', fontWeight: 700, padding: '3px 8px' }}>Annonce</div>
              <div className="post-title">Inscriptions ouvertes pour l'AG 2024</div>
              <div className="post-meta">Sophie Bernard · 28 mai 2024 · 2 min de lecture</div>
            </div>
            <div className="post-card">
              <div className="post-img">🤝</div>
              <div className="post-tag t-c" style={{ borderRadius: '6px', fontSize: '10px', fontWeight: 700, padding: '3px 8px' }}>Partenariat</div>
              <div className="post-title">Nouveau partenariat avec la Mairie de Lyon</div>
              <div className="post-meta">Marie Dupont · 15 mai 2024 · 4 min de lecture</div>
            </div>
            <div className="post-card">
              <div className="post-img">🎉</div>
              <div className="post-tag" style={{ borderRadius: '6px', fontSize: '10px', fontWeight: 700, padding: '3px 8px', background: 'rgba(124,92,252,0.12)', color: 'var(--purple)', border: '1px solid rgba(124,92,252,0.2)' }}>Événement</div>
              <div className="post-title">Retour sur la soirée de printemps</div>
              <div className="post-meta">Jean Martin · 3 mai 2024 · 5 min de lecture</div>
            </div>
            <div className="spacer"></div>
          </div>

          {/* ═══ PAGE : NOTIFICATIONS ═══ */}
          <div className={pageClass('notifications')} id="page-notifications" data-testid="page-notifications">
            <div className="app-header">
              <div className="header-top">
                <div className="page-back" onClick={goBack} data-testid="back-notifications">← Notifications</div>
                <div style={{ fontSize: '12px', color: 'var(--cyan)', fontWeight: 600, cursor: 'pointer' }}>Tout lire</div>
              </div>
            </div>
            <div style={{ padding: '0 22px', marginBottom: '12px' }}>
              <div style={{ fontSize: '12px', fontWeight: 700, color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Aujourd'hui</div>
            </div>
            <div className="notif-item"><div className="notif-icon ni-c">✅</div><div className="notif-body"><div className="notif-text"><strong>Pierre Durand</strong> a payé sa cotisation annuelle (30 €)</div><div className="notif-time">Il y a 12 min</div></div><div className="notif-unread"></div></div>
            <div className="notif-item"><div className="notif-icon ni-o">📅</div><div className="notif-body"><div className="notif-text">Rappel : <strong>Tournoi de Pétanque</strong> dans 5 jours — 32 inscrits</div><div className="notif-time">Il y a 1 heure</div></div><div className="notif-unread"></div></div>
            <div className="notif-item"><div className="notif-icon ni-p">👤</div><div className="notif-body"><div className="notif-text"><strong>Alice Leroy</strong> a rejoint l'association</div><div className="notif-time">Il y a 3 heures</div></div><div className="notif-unread"></div></div>
            <div style={{ padding: '12px 22px' }}>
              <div style={{ fontSize: '12px', fontWeight: 700, color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Hier</div>
            </div>
            <div className="notif-item"><div className="notif-icon ni-c">💬</div><div className="notif-body"><div className="notif-text"><strong>Jean Martin</strong> vous a envoyé un message</div><div className="notif-time">Hier, 16h42</div></div></div>
            <div className="notif-item"><div className="notif-icon ni-o">📄</div><div className="notif-body"><div className="notif-text"><strong>Statuts 2024.pdf</strong> a été ajouté aux documents</div><div className="notif-time">Hier, 14h32</div></div></div>
            <div className="notif-item"><div className="notif-icon ni-r">⚠️</div><div className="notif-body"><div className="notif-text"><strong>Thomas Moreau</strong> — cotisation expirée depuis 30 jours</div><div className="notif-time">Hier, 09h00</div></div></div>
            <div className="spacer"></div>
          </div>

        </div>{/* /pages */}

        {/* BOTTOM NAV */}
        <div className="bottom-nav">
          <div
            className={'bn' + (NAV_PAGES.includes(currentPage) && currentPage === 'home' ? ' active' : '')}
            onClick={() => showPage('home')}
            data-testid="nav-home"
          >
            <div className="bn-bar"></div>
            <div className="bn-icon">🏠</div>
            <div className="bn-lbl">Accueil</div>
          </div>
          <div
            className={'bn' + (currentPage === 'membres' ? ' active' : '')}
            onClick={() => showPage('membres')}
            data-testid="nav-membres"
          >
            <div className="bn-bar"></div>
            <div className="bn-icon">👥</div>
            <div className="bn-lbl">Membres</div>
          </div>
          <div
            className={'bn' + (currentPage === 'agenda' ? ' active' : '')}
            onClick={() => showPage('agenda')}
            data-testid="nav-agenda"
          >
            <div className="bn-bar"></div>
            <div className="bn-icon">📅</div>
            <div className="bn-lbl">Agenda</div>
            <div className="bn-badge">3</div>
          </div>
          <div
            className={'bn' + (currentPage === 'messages' ? ' active' : '')}
            onClick={() => showPage('messages')}
            data-testid="nav-messages"
          >
            <div className="bn-bar"></div>
            <div className="bn-icon">💬</div>
            <div className="bn-lbl">Messages</div>
            <div className="bn-badge orange">12</div>
          </div>
          <div
            className={'bn' + (currentPage === 'profil' ? ' active' : '')}
            onClick={() => showPage('profil')}
            data-testid="nav-profil"
          >
            <div className="bn-bar"></div>
            <div className="bn-icon">👤</div>
            <div className="bn-lbl">Profil</div>
          </div>
        </div>

      </div>{/* /phone */}
    </div>
  );
}
